<template>
  <div class="container">
    <div class="content" v-loading="loading">
      <div class="order-logo">
        <img style="width: 210px;" src="https://testing-1253588055.cos.ap-shanghai.myqcloud.com/assets/WePayLogo.png" alt="">
      </div>
      <div class="order-content">
        <div class="order-info">
          <div>订单编号：{{data.OutTradeNo}}</div>
          <div>报名编号：{{data.OrderCode}}</div>
          <div>报名课程：{{data.CourseName}}</div>
          <div>报名人数：{{data.TotalEmployeeCount}} 人</div>
          <div class="order-price">应付金额：<span>￥{{data.TotalPrice}}</span></div>
        </div>
        <div class="order-code">
          <div>
            <div class="qrcode" ref="qrCodeUrl"></div>
          </div>
          <div style="margin-top: 20px;"><img src="https://testing-1253588055.cos.ap-shanghai.myqcloud.com/assets/%E8%AF%B4%E6%98%8E%E6%96%87%E5%AD%97.png" alt=""></div>
        </div>
        <div class="order-tips">
          <span>温馨提示：</span>
          <p>该费用为技术服务费，由技术公司收取。培训机构不收取任何培训费。</p>
          <p>课程开通后可以在企业管理系统>发票中心申请开票。</p>
          <p>继续教育缴费、开票事项咨询QQ群：812449855。</p>
          <div style="margin-left: 32px; margin-top: 24px;">
            <el-checkbox v-model="checked"></el-checkbox>&nbsp;&nbsp;我已知晓
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button class="k-btn-primary lg" @click="onSubmit">支付完成</el-button>
      <el-button class="k-btn-default lg" @click="onCancel">取消</el-button>
    </div>
    <el-dialog id="dialog_result" :title="payResult == 1 ? '报名成功' : '报名失败'" :visible.sync="handleResultDialogVisible" width="580px" :before-close="handleResultDialogCancel" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="box-result">
        <div v-if="payResult == 1" class="box-result-content">
          <div class="box-result-icon-success"><i class="el-icon-success"></i></div>
          <div>恭喜您，报名成功！审核需要 1~2 个工作日，通过审核后学员可以使用身份证号及密码（默认：000000）登录平台进行学习。您可以在“发票中心”中申请开票。</div>
        </div>
        <div v-else class="box-result-content">
          <div class="box-result-icon-waring"><i class="el-icon-warning"></i></div>
          <div>对不起，报名失败！请确认您已扫码并完成支付。您可以通过“我的课程报名>在线支付”功能继续完成支付。</div>
        </div>
        <div class="box-result-fooler">
          <el-button class="el-button el-button--default el-button--small" @click="handleResultDialogCancel">取消</el-button>
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="handleResultDialogSubmit">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      learnId: null,
      data: {
        OutTradeNo: null,
        TotalPrice: 0,
        CodeUrl: null
      },
      loading: true,
      qrcode: null,
      handleResultDialogVisible: false,
      payResult: 2,
      checked: false
    }
  },
  mounted() {
    let that = this;
    let learnId = this.$route.query.learnId;
    this.$store.dispatch('getLearnWeixinPayCode', { learnId: learnId }).then((res) => {
      let data = res.Data;

      // 如果当前订单已经支付，跳转我的报名界面
      if (res.Code === 2) {
        that.$alert(res.Message, '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        that.$router.push({ name: 'qyglwdbm' });
        return;
      }
      // 生成二维码
      this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: data.CodeUrl,
        width: 260,
        height: 260,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })

      that.data = data;
      that.loading = false;
    });
  },
  methods: {
    onCancel() {
      this.$router.push({ name: 'qyglwdbm' })
    },
    onSubmit() {
      let that = this;
      if (!that.checked) {
        that.$alert('请阅读“温馨提示”并勾选我已知晓', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      };
      this.$store.dispatch('getLearnWeixinPayResult', { learnId: this.$route.query.learnId, outTradeNo: this.data.OutTradeNo }).then(res => {
        if (res.MsgCode === 0) {
          // 判断该课程是否开启在线支付
          this.payResult = res.Data.Result;
          this.handleResultDialogVisible = true;
        } else {
          that.$alert(res.Message, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      });
    },
    handleResultDialogCancel() {
      this.handleResultDialogVisible = false;
      this.$router.push({ name: 'qyglwdbm' });
    },
    handleResultDialogSubmit() {
      this.$router.push({ name: 'qyglwdbm' });
    }
  }
}
</script>
<style lang='scss' scoped >
.container {
  display: flex;
  flex-direction: column;
  .content {
    .order-logo {
      margin: 80px 0 36px 0;
    }
    .order-content {
      display: flex;
      justify-content: space-between;
      height: 460px;
      line-height: 24px;
      color: #333333;
      .order-info {
        width: 400px;
        .order-price {
          margin-top: 32px;
          span {
            font-size: 28px;
            color: #16cfd0;
          }
        }
      }
      .order-code {
        width: 350px;
        display: flex;
        flex-direction: column;
      }
      .order-tips {
        width: 315px;
        color: #ff6715;
        span {
          display: block;
          margin-bottom: 1em;
        }
        p {
          text-indent: 32px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .footer {
    margin-top: 32px;
    display: flex;
    justify-content: flex-end;
  }
  .box-result {
    .box-result-content {
      margin-top: -32px;
      margin-left: 14px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .box-result-icon-success {
        color: #16cfd0;
        font-size: 24px;
        margin-right: 10px;
      }
      .box-result-icon-waring {
        color: #ff6715;
        font-size: 24px;
        margin-right: 10px;
      }
    }
    .box-result-fooler {
      display: flex;
      justify-content: flex-end;
      margin-top: 32px;
      margin-right: 12px;
    }
  }
}
</style>
<style scoped>
#dialog_result >>> .el-dialog {
  margin: 0 !important;
  width: 904px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#dialog_result >>> .el-dialog__header {
  padding: 32px !important;
}
#dialog_result >>> .el-dialog__title {
  font-size: 24px !important;
}
.order-tips >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ff6715;
  border-color: #ff6715;
}
.order-tips >>> .el-checkbox__inner {
  border: 1px solid #ff6715;
}
.order-tips >>> .el-checkbox__inner:hover {
  border-color: #ff6715;
}
</style>



// WEBPACK FOOTER //
// src/views/home/course_enroll_pay.vue